module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('org-nav')], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Formulário de Inscrição")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e1c5870"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/org/Inscricao.vue
// module id = 253
// module chunks = 1